import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { Check } from '../../../components/Icon';
import { Loader } from '../../../components/Loader';
import { IsOpen } from '../../../components/Icon';
import { selectWorks } from '../../Api/selectors';
import { setVehicleProperty } from '../actions';
import { REQUEST_VEHICLE, REQUEST_VEHICLE_PROPERTY_UPDATE } from '../constants';
import cn from 'classnames';
import styles from './CardLabel.module.css';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import { WS1_1_Labels } from '../../KanbanBoards/cells/WS/WS1_1_Labels';
import { selectActions } from '../../Actions/selectors';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import {
  DEP_FINANCE,
  DEP_COMMERCE,
  DEP_WALSTREET,
  DEP_ADMINISTRATION,
  DEP_IT,
  DEP_WORKSHOP,
  DEP_ADMIN,
  DEP_TRANSPORT,
} from '../../../components/Permission/constants';
import { Permission } from '../../../components/Permission';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';

const Container = styled.div`
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }
`;

const STATE = {
  showActionModal: false,
  showNotification: false,
  isOpen: false,
};

/* eslint-disable react/prefer-stateless-function */
class VehicleLabelCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  applyDisabled() {
    let disabled = false;

    if (env.clientId === AppClientId.HOOIKAMMER) {
      disabled = true;
    }

    return disabled;
  }

  getActionIdByName(name) {
    return this.props?.actions?.find(a => a.functionName === name)?.id ?? null;
  }

  renderActionModal() {
    if (!this.props.webLogin) {
      return (
        <div className="mb-2">
          <WS1_1_Labels
            vehicleDetails
            onClose={() => this.setState({ showActionModal: false, showNotification: false })}
            cell={{ vehicle: this.props.vehicle }}
            action={{ label: 'label', id: this.getActionIdByName('WS1_1_Labels') }}
            payload={{ task_name: 'task_spray' }}
            column={{ label: 'WS1_1_Labels' }}
          />
        </div>
      );
    } else {
      return null;
    }
  }

  renderNotification() {
    return (
      <ModalComponent onClose={() => this.setState({ showNotification: false })}>
        <VBox className="d-flex gap-2">
          <ButtonComponent
            style="ButtonSoftPrimaryFullWidth"
            disabled={this.applyDisabled()}
            onClick={() => {
              this.setState({ showActionModal: true });
            }}
          >
            {this.lbl('vehicle.label_printer.notification.check_and_print')}
          </ButtonComponent>
          <ButtonComponent
            style="ButtonSoftPrimaryFullWidth"
            onClick={() => {
              this.props.print(res => {
                this.setState({ showNotification: false });
              });
            }}
          >
            {this.lbl('vehicle.label_printer.notification.print_only')}
          </ButtonComponent>
          <ButtonComponent
            style="ButtonSoftPrimaryFullWidth"
            disabled={this.applyDisabled()}
            onClick={() => {
              this.props.taskLabelComplete(res => {
                this.setState({ showNotification: false });
              });
            }}
          >
            {this.lbl('vehicle.label_printer.notification.task_labels')}
          </ButtonComponent>
        </VBox>
      </ModalComponent>
    );
  }

  render() {
    const vehicle = this.props.vehicle;
    return (
      <Card className={cn('vehicle-info-card info-card data', styles.card)}>
        {this.state.showActionModal && this.renderActionModal()}
        {this.state.showNotification && this.renderNotification()}
        <Container>
          <HBox>
            <h2 className="card-title mb-2 text-muted">{this.lbl('vehicle.info.label.title')}</h2>

            <div style={{ marginLeft: 'auto' }} onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
              <IsOpen />
            </div>
          </HBox>
          {this.state.isOpen && (
            <>
              {this.props.vehicle.label_printer_queue == '1' ? (
                <HBox center vCenter>
                  <Loader small />
                  &nbsp;
                  {this.lbl('vehicle.property.label_printer_queue.1')}
                </HBox>
              ) : null}
              <ButtonComponent style="ButtonSoftEditFullWidth" onClick={this.setStateFn({ showNotification: true })}>
                {this.props.vehicle.label_printer_queue == '2' ? (
                  <>
                    <Check />
                    {this.lbl('vehicle.property.label_printer_queue.2')}
                  </>
                ) : (
                  this.lbl('vehicle.info.label.print_label')
                )}
              </ButtonComponent>
            </>
          )}
        </Container>
      </Card>
    );
  }
}

VehicleLabelCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    actions: selectActions(),
    works: selectWorks([REQUEST_VEHICLE_PROPERTY_UPDATE, REQUEST_VEHICLE]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    print(callback) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'label_printer_queue', '1', callback));
    },
    taskLabelComplete(callback) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'task_labels', '0', callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleLabelCard = compose(withConnect, withRouter)(VehicleLabelCardComp);
